import { Box } from "@itandi/itandi-bb-ui/Box";
import React from "react";
import { ReportImageNavigation } from "~/components/common/reports/navigation/ReportImageNavigation";
import { StatusHandleClientButtons } from "~/components/common/statuses/StatusHandleClientButtons";
import { useDealContext } from "~/context/DealContext";
import { useDealCompletionReportImages } from "~/hooks/deals/useDealCompletionReportImages";
import useItandiAccount from "~/hooks/useItandiAccount";
import {
	AWAITING_ACCEPTANCE,
	FINISHED,
	IN_CONSTRUCTION,
	statusMovingValidation
} from "~/models/Status";
import { PATH as COMPLETION_REPORT_PATH } from "~/pages/deals/[id]/completion_reports";
import Styles from "./statuses.module.scss";

export const AwaitingAcceptance: React.FC = () => {
	const deal = useDealContext();
	const reportsApi = useDealCompletionReportImages();
	const { data: reportImages } = reportsApi.index(deal.id);
	const { data: account } = useItandiAccount().currentAccount();
	const forwardStatusDisabled = React.useMemo(() => {
		if (account === null) return false;
		return statusMovingValidation[AWAITING_ACCEPTANCE](account);
	}, [account]);
	return (
		<div>
			<h3 className={Styles.Title}>工事が完了しました</h3>
			<Box marginY={16}>
				<p>完了報告画像を確認し、問題がなければステータスを進めてください。</p>
			</Box>
			{reportImages !== null && (
				<ReportImageNavigation
					detailPageButtonLabel="画像確認画面"
					detailPagePath={COMPLETION_REPORT_PATH(deal.id)}
					reportImages={reportImages}
					title="完了報告画像を確認してください"
				/>
			)}
			<StatusHandleClientButtons
				forwardDisabled={!forwardStatusDisabled}
				nextStatusId={FINISHED}
				prevStatusId={IN_CONSTRUCTION}
			/>
		</div>
	);
};
